import React from 'react';

import './Pagination.css';

const Pagination = ({
  totalPosts,
  postsPerPage,
  currentPage,
  setCurrentPage,
  maxVisiblePages = 5,
}) => {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const getPageNumbers = () => {
    const pages = [];

    if (currentPage > Math.floor(maxVisiblePages / 2) + 1) {
      pages.push(1);
    }

    if (currentPage > Math.floor(maxVisiblePages / 2) + 2) {
      pages.push('ellipsis');
    }

    const start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const end = Math.min(
      totalPages,
      currentPage + Math.floor(maxVisiblePages / 2)
    );
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - (Math.floor(maxVisiblePages / 2) + 1)) {
      pages.push('ellipsis');
    }

    if (currentPage < totalPages - Math.floor(maxVisiblePages / 2)) {
      pages.push(totalPages);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className='pagination-container'>
      <button
        onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Prev
      </button>

      {pageNumbers.map((num, index) =>
        num === 'ellipsis' ? (
          <span key={index} className='ellipsis'>
            ...
          </span>
        ) : (
          <button
            key={index}
            onClick={() => handleClick(num)}
            className={num === currentPage ? 'active' : ''}
          >
            {num}
          </button>
        )
      )}

      <button
        onClick={() =>
          currentPage < totalPages && setCurrentPage(currentPage + 1)
        }
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
